import React, { useState } from 'react';
import { documentsAPI } from '../../../api';

const DocumentUploader = () => {
  const [file, setFile] = useState(null);
  const [groupId, setGroupId] = useState('');
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!file || !groupId || !name) {
      setMessage('Remplis tous les champs');
      return;
    }

    try {
      await documentsAPI.uploadDocument(groupId, name, file);
      setMessage('Upload réussi ✔️');
    } catch (err) {
      console.error(err);
      setMessage('Erreur lors de l’upload ❌');
    }
  };

  return (
    <form onSubmit={handleUpload}>
      <input type="text" value={groupId} onChange={(e) => setGroupId(e.target.value)} placeholder="Group ID" />
      <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nom du document" />
      <input type="file" onChange={(e) => setFile(e.target.files[0])} accept="application/pdf" />
      <button type="submit">Uploader</button>
      <p>{message}</p>
    </form>
  );
};

export default DocumentUploader;
